import { render, staticRenderFns } from "./VCol.vue?vue&type=template&id=7e1bcf34&scoped=true&"
import script from "./VCol.vue?vue&type=script&lang=js&"
export * from "./VCol.vue?vue&type=script&lang=js&"
import style0 from "./VCol.vue?vue&type=style&index=0&id=7e1bcf34&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e1bcf34",
  null
  
)

export default component.exports